import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import plus from "../../../Components/assets/icons/a1.png";
import colunms from "../../../Components/assets/icons/LINES.png";
import pen from "../../../Components/assets/icons/pen.png";
import eye from "../../../Components/assets/icons/eye.png";
import basket from "../../../Components/assets/icons/basket.png";
import search1 from "../../../Components/assets/icons/search.png";
import top from "../../../Components/assets/icons/top.png";
import Table from "react-bootstrap/Table";
import circle from "../../assets/icons/circle.png";
import rigth from "../../assets/icons/rigth.png";
import save from "../../assets/icons/save.png";
import cancel from "../../assets/icons/cross.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../../Header/Header";
import Modal from "react-bootstrap/Modal";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faDownload, fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Offcanvas from "react-bootstrap/Offcanvas";

import toast, { Toaster } from "react-hot-toast";
import Card from "react-bootstrap/Card";
import Select from "react-select";
import AddOffCanvance from "./Add";
import EditOffCanvance from "./Edit";
import { Container, Row, Col, Button, Form, InputGroup } from "react-bootstrap";
import { Context } from "../../../utils/context";
import { FaEye } from "react-icons/fa";
import { Controller, useForm } from "react-hook-form";
import { getDownloadDataExcel, postData } from "../../../utils/api";
import { toUnitless } from "@mui/material/styles/cssUtils";
import Successfull_Modal from "../../common/Successfull_Modal/Successfull_Modal";
import Pagination_Holder from "../../common/Pagination_Holder/Pagination_Holder";
import Pagination from "react-bootstrap/Pagination";
library.add(fas);

// ********************************************************************************************************************************************************

const Tables = (props) => {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    isAllow,
    IMG_URL,
    Per_Page_Dropdown,
    Select2Data,
    SelectUsers,
  } = useContext(Context);
  const [onPageChange, setonPageChange] = useState(1);

  const [totalPages, settotalPages] = useState();

  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };

  const paginationItems = [];
  for (let page = 1; page <= totalPages; page++) {
    paginationItems.push(
      <Pagination.Item
        key={page}
        active={page === onPageChange}
        onClick={() => handlePageChange(page)}
      >
        {page}
      </Pagination.Item>
    );
  }

  const {
    control,
    register,
    handleSubmit,
    getValues,
    formState: { errors },
    watch,
    setValue,
    reset,
  } = useForm();

  const [data, setData] = useState([]);
  const [receivedData, setReceivedData] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(5);
  const [search, setSearch] = useState("");
  const [resetData, setResetData] = useState();
  const [show, setShowAdd] = useState(false);
  const [show1, setShowEdit] = useState(0);
  const [option, setOption] = useState();
  const [searchByUser, setSearchByUser] = useState(null);
  const [searchCategory, setSearchCategory] = useState("");
  const [searchSupplier, setSearchSupplier] = useState("");
  const [searchSubCategory, setSearchSubCategory] = useState("");
  const [searchChildSubCategory, setSearchChildSubCategory] = useState("");

  const { id } = useParams();

  useEffect(() => {
    setSearchByUser(id || null); // Set to null if id is undefined or null
    getDataAll();
  }, [id]);

  useEffect(() => {
    getDataAll();
  }, [searchByUser]);

  const [user, setUser] = useState({});
  const GetUserData = async () => {
    const response = await getData(`/usersingleget`);
    if (response?.success) {
      setUser(response?.data);
    }
  };
  useEffect(() => {
    GetUserData();
  }, []);

  const [changeStatus, setChangeStatus] = useState();
  const [changeReceiveStatus, setChangeReceiveStatus] = useState();
  const [modalShow, setModalShow] = useState(false);

  const getDataAll = async () => {
    const queryString = `/stock-management/order-purchase?page=${onPageChange}&per_page=${perPage}&term=${search}&searchByUser=${id}&searchSupplier=${
      searchSupplier?.value || ""
    }&searchSubCategory=${
      searchSubCategory?.value || ""
    }&searchChildSubCategory=${searchChildSubCategory?.value || ""}`;
    const response = await getData(queryString);
    await setData(response);
    setCurrentPage(response?.data?.currentPage);
    setperPage(response?.data?.per_page);
    setSearch(response?.data?.search_name);
    settotalPages(response?.data?.totalPages);
    setOption(await Per_Page_Dropdown(response?.data?.totalEntries));
    const newData = response?.data?.data;
    if (newData) {
      const newIds = newData.map((d) => d?.id);
      setAllChecked(newIds);
    }
  };
  useEffect(() => {
    getDataAll();
  }, [
    changeStatus,
    perPage,
    resetData,
    show,
    show1,
    search,
    searchCategory,
    searchSubCategory,
    searchChildSubCategory,
    searchSupplier,
    onPageChange,
  ]);

  const [productOption, setProduct] = useState([]);
  const GetAllProducts = async () => {
    const response = await getData("/all-products");
    if (response?.success) {
      setProduct(await Select2Data(response?.data, "product_id"));
    }
  };

  useEffect(() => {
    GetAllProducts();
  }, []);

  const ChangeStatus = async (id) => {
    const response = await editStatusData(
      `/stock-management/order-purchase/${id}`
    );
    setChangeStatus(response);
  };

  const ChangeStatusReceive = async (data) => {
    const DataToSend = new FormData();
    const product = [];

    // Show the modal after 2 seconds
    // setTimeout(() => {
    setModalShow(true);
    setShowStatus(false);

    // Close the modal after 3 seconds
    setTimeout(() => {
      setModalShow(false);
      // window.location.reload();
    }, 3000); // 3000 ms = 3 seconds
    // }, 2000); // Delay to show modal (2 seconds)

    if (getValues("type")?.value === "Single") {
      data.product?.forEach((item) => {
        const addOn = {
          unit: item.unit,
          unit_type: item.unit_type?.value,
          product_single_v_id: item.product_single_v_id.value,
        };
        product.push(addOn);
      });
    }

    if (getValues("type")?.value === "Multiple") {
      data.product.forEach((mainVariant) => {
        const m_variants = mainVariant.m_sub_variants?.map((variant) => ({
          product_m_sub_v_id: variant?.product_m_sub_v_id?.value,
          unit: variant?.unit,
          unit_type: variant?.unit_type?.value,
        }));

        const mainVariantData = {
          product_m_main_id: mainVariant.product_m_main_id?.value,
          m_sub_variants: m_variants,
        };

        product.push(mainVariantData);
      });
    }

    DataToSend.append("product", JSON.stringify(product));
    DataToSend.append("id", data.id);

    ChangeStatus(data.id);

    try {
      const response = await postData(
        `/stock-management/order-purchase/receive/${data.id}`,
        DataToSend
      );
      const result = await response.json();
      setChangeReceiveStatus(result);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const GetEditData = async (id) => {
    const response = await getData(
      `/stock-management/order-purchase/receive/${id}`
    );

    setReceivedData(response?.data);
    reset(response?.data);
  };

  useEffect(() => {
    GetEditData();
  }, []);

  // Delete module.....................................................
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [recordToDeleteName, setRecordToDeleteName] = useState(null);

  const showDeleteRecord = async (id, name) => {
    setShowDeleteModal(true);
    setRecordToDeleteId(id);
    setRecordToDeleteName(name);
  };

  // Modal function
  const handleClose = () => setShowAdd(false);
  const handleShow = () => setShowAdd(true);

  const handleClose1 = () => setShowEdit(0);
  const handleShow1 = (id) => {
    setShowEdit(id);
  };

  const DeleteRecord = async () => {
    setShowDeleteModal(false);
    if (recordToDeleteId) {
      const response = await deleteData(
        `/stock-management/order-purchase/${recordToDeleteId}`
      );
      await ErrorNotify(recordToDeleteName);
      setChangeStatus(response);
      setRecordToDeleteId(null);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setRecordToDeleteId(null);
  };

  //toggle/
  const [visible, setVisibel] = useState({
    col0: true,
    col1: true,
    col2: true,
    col3: true,
    col4: true,
    col5: true,
    col6: true,
    col7: true,
    col8: true,
    col9: true,
    col10: true,
    col11: true,
  });

  //toggle columnns.........
  const toggleColumn = (event, columnName) => {
    event.preventDefault();
    setVisibel((prev) => ({
      ...prev,
      [columnName]: !prev[columnName],
    }));
  };

  const [supplier, setSupplier] = useState([]);

  const GetAllSupplier = async () => {
    const response = await getData("/all-suppliers");
    if (response?.success) {
      setSupplier(await SelectUsers(response?.data, "supplier_id"));
    }
  };

  useEffect(() => {
    GetAllSupplier();
  }, []);

  const [showStatus, setShowStatus] = useState(false);

  const handleCloseStatus = () => setShowStatus(false);
  const handleShowStatus = () => setShowStatus(true);

  // Select All Functionality
  const [selectAllChecked, setSelectAllChecked] = useState([]);
  const [allChecked, setAllChecked] = useState([]);

  const handleSelectAll = async () => {
    await setSelectAllChecked(allChecked);
  };

  const handleChange = async (e) => {
    const { value, checked } = e.target;

    if (value === "selectAll") {
      if (checked) {
        handleSelectAll();
      } else {
        await setSelectAllChecked([]);
      }
    } else {
      if (checked) {
        await setSelectAllChecked([...selectAllChecked, Number(value)]);
      } else {
        await setSelectAllChecked(
          selectAllChecked.filter((e) => e !== Number(value))
        );
      }
    }
  };

  const HandleDownload = async () => {
    if (selectAllChecked.length == 0) {
      alert("Please Select Atleast One Record");
    } else {
      try {
        await getDownloadDataExcel(
          "/stock-management/order-purchase/download",
          selectAllChecked,
          "Stock Details List"
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  return (
    <>
      <div className="main-advancedashboard">
        <Header
          title={"Seller Purchase Order"}
          link={"/stock-management/order-purchase"}
        />
        <section className="AdvanceDashboard">
          <div className="col-xxl-12 col-xl-12  ">
            <div className="row MainRowsec">
              <section className="Tabels tab-radio tab-radio mt-5">
                <div className="">
                  {/* container */}
                  <div className="row">
                    {isAllow.includes(250) ? (
                      <div className="col-xxl-2 col-xl-2 col-lg-4 col-md-6 col-sm-6 col-12">
                        <Link
                          // to="/employee/employee_details/add"
                          type="button"
                          className="btn btn-add pe-3"
                        >
                          <div className="add me-3">
                            <div onClick={() => handleShow()}>
                              <p className="add-sub-txttt">
                                {" "}
                                <img
                                  src={plus}
                                  className="plus me-2 ms-0"
                                  alt=""
                                />
                                Add Purchase Order
                              </p>
                            </div>
                          </div>
                        </Link>
                      </div>
                    ) : (
                      <></>
                    )}
                    <div className="col-xxl-2 col-xl-2 col-lg-4 col-md-6 col-sm-6 col-12">
                      <div className="add">
                        <div className="dropdown"></div>
                      </div>
                    </div>
                    <div className="border-line my-3"></div>
                    <div className="row">
                      <div className=" col-12"></div>
                      <div className=" col-12">
                        <div className="row align-items-end">
                          <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-6 col-12 mb-2">
                            <div className="num me-2">
                              <Select
                                isSearchable
                                options={supplier}
                                value={searchSupplier}
                                placeholder="Select Supplier"
                                onChange={(e) => {
                                  setSearchSupplier(e);
                                  handlePageChange(1);
                                  //   GetAllSubCategory(e.value);
                                }}
                              />
                            </div>
                          </div>

                          {/* <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-6 col-12 mt-md-0 mt-3">
                            <div className="num me-2 text-end">
                              <input
                                type="text"
                                className="form-control"
                                id=""
                                value={search}
                                onChange={(e) => {
                                  setSearch(e.target.value);
                                }}
                              />
                            </div>
                          </div> */}
                          <div className="col-xxl-1 col-xl-2  col-lg-2  col-md-2 col-12 mb-2">
                            <div className="Search-1">
                              <button
                                type="button"
                                onClick={() => {
                                  setSearchSupplier("");
                                  setSearch("");
                                  setSearchCategory("");
                                  setSearchSubCategory("");
                                  setSearchChildSubCategory("");

                                  setResetData(!resetData);
                                }}
                                className="btn btn-reset w-100"
                              >
                                Reset
                              </button>
                            </div>
                          </div>

                          <div className="col-xxl-2 col-xl-3 col-lg-4 col-md-6 col-12 mb-2">
                            <button
                              className="btn btn-success "
                              onClick={HandleDownload}
                            >
                              <FontAwesomeIcon
                                className="me-1"
                                icon={faDownload}
                              />
                              Downlaod Excel
                            </button>
                          </div>

                          {/* <div className="Search me-2">
                            <Button
                              type="button"
                             onClick={getDataAll}
                              className="btn btn-search btn btn-primary w-100"
                            >
                              <img src={search1} className="search" alt="" />
                            </Button>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="border-line my-3"></div>
                  <div className="row mt-3">
                    <div className="data table-responsive">
                      <Table striped bordered hover responsive center>
                        <thead>
                          <tr className="">
                            <th>
                              <input
                                type="checkbox"
                                value="selectAll"
                                checked={
                                  allChecked.length === selectAllChecked.length
                                }
                                onChange={handleChange}
                                id="selectAll"
                                className="me-1"
                              ></input>
                              Select
                            </th>
                            {visible.col1 && <th className="sr">Sr. No.</th>}
                            {visible.col2 && (
                              <th
                                style={{ width: "900px" }}
                                className="tax-name"
                              >
                                Supplier
                              </th>
                            )}
                            {visible.col4 && (
                              <th
                                style={{ width: "900px" }}
                                className="tax-name"
                              >
                                Batch Number
                              </th>
                            )}
                            {visible.col5 && (
                              <th
                                style={{ width: "900px" }}
                                className="tax-name"
                              >
                                Products
                              </th>
                            )}{" "}
                            {visible.col7 && (
                              <th
                                style={{ width: "900px" }}
                                className="tax-name"
                              >
                                Varient
                              </th>
                            )}
                            {visible.col8 && (
                              <th
                                style={{ width: "900px" }}
                                className="tax-name"
                              >
                                Single Varient Name
                              </th>
                            )}
                            {visible.col9 && (
                              <th
                                style={{ width: "900px" }}
                                className="tax-name"
                              >
                                Multiple Varient Main Name
                              </th>
                            )}
                            {visible.col10 && (
                              <th
                                style={{ width: "900px" }}
                                className="tax-name"
                              >
                                Multiple Varient Sub Name
                              </th>
                            )}
                            {visible.col7 && (
                              <th
                                style={{ width: "900px" }}
                                className="tax-name"
                              >
                                Existing Units
                              </th>
                            )}
                            {visible.col6 && (
                              <th
                                style={{ width: "900px" }}
                                className="tax-name"
                              >
                                Quantity
                              </th>
                            )}
                          
                            {visible.col11 && (
                              <th
                                style={{ width: "900px" }}
                                className="tax-name"
                              >
                                Received Unit/Boxes
                              </th>
                            )}
                            {visible.col8 && (
                              <th
                                style={{ width: "900px" }}
                                className="tax-name"
                              >
                                Status
                              </th>
                            )}
                            {visible.col9 && (
                              <th
                                style={{ width: "900px" }}
                                className="tax-name"
                              >
                                {user?.id === 1 ? "Action " : "Action "}
                              </th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {/* {isAllow.includes(5) ? ( */}
                          {data?.data?.data?.length > 0 ? (
                            data.data.data.map((d, index) => {
                              const paginatedIndex =
                                (onPageChange - 1) * perPage + index + 1;
                              return (
                                <tr className="" key={index}>
                                  <td>
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      value={d?.id}
                                      name="perselected"
                                      checked={selectAllChecked.includes(d?.id)}
                                      onChange={handleChange}
                                      id="flexCheckDefault"
                                    />
                                  </td>
                                  {visible.col1 && <td>{paginatedIndex}.</td>}{" "}
                                  {visible.col2 && (
                                    <td>{d?.user?.first_name}</td>
                                  )}
                                  {visible.col4 && <td>{d?.batch_no}</td>}
                                  {visible.col5 && (
                                    <td>{d?.product?.name}</td>
                                  )}{" "}
                                  {visible.col7 && <td>{d?.type}</td>}{" "}
                                  {visible.col8 && (
                                    <td>
                                      {d?.purchase_order_s_details?.map(
                                        (value, index) => (
                                          <div className="text-holder">
                                            <p className="mb-0" key={index}>
                                              {value?.product_variant?.v_name}
                                              <br />
                                            </p>
                                            <hr />
                                          </div>
                                        )
                                      )}
                                    </td>
                                  )}
                                  {visible.col9 && (
                                    <td>
                                      {d?.purchase_order_m_details?.map(
                                        (value, index) => (
                                          <div
                                            className="text-holder"
                                            key={index}
                                          >
                                            <p className="mb-0">
                                              {
                                                value?.product_multiple_main
                                                  ?.varient_name
                                              }
                                            </p>
                                            <hr />
                                          </div>
                                        )
                                      )}
                                    </td>
                                  )}
                                  {visible.col10 && (
                                    <td>
                                      {/* {d?.purchase_order_m_details?.map(
                                      (value, index) => (
                                        <div key={index}>
                                          {value?.purchase_order_m_sub_details?.map(
                                            (data, subIndex) => (
                                              <div key={subIndex}>
                                                {
                                                  data?.product_multiple_variant
                                                    ?.varient_sub_name
                                                }
                                              </div>
                                            )
                                          )}
                                        </div>
                                      )
                                    )} */}

                                      {d?.purchase_order_m_details?.map(
                                        (value, index) => (
                                          <div key={index}>
                                            {value?.purchase_order_m_sub_details?.map(
                                              (data, subIndex) => (
                                                <div
                                                  className="text-holder"
                                                  key={subIndex}
                                                >
                                                  <p className="mb-0">
                                                    {
                                                      data
                                                        ?.product_multiple_variant
                                                        ?.varient_sub_name
                                                    }
                                                  </p>
                                                </div>
                                              )
                                            )}{" "}
                                            <hr />
                                          </div>
                                        )
                                      )}
                                    </td>
                                  )}
                                  {visible.col7 && (
                                    <td>
                                      {d.type == "Single"
                                        ? d?.purchase_order_s_details?.map(
                                            (value, index) => (
                                              <div className="text-holder">
                                                <p className="mb-0" key={index}>
                                                  {value?.existing_unit || 0}{" "}
                                                  units <br />
                                                </p>
                                                <hr />
                                              </div>
                                            )
                                          )
                                        : d?.purchase_order_m_details?.map(
                                            (value, index) => (
                                              <div key={index}>
                                                {value?.purchase_order_m_sub_details?.map(
                                                  (data, subIndex) => (
                                                    <>
                                                      <div key={subIndex}>
                                                        {data?.existing_unit ||
                                                          0}{" "}
                                                        units{" "}
                                                      </div>
                                                    </>
                                                  )
                                                )}
                                                <hr />
                                              </div>
                                            )
                                          )}
                                    </td>
                                  )}
                                  {visible.col6 && (
                                    <td>
                                      {d.type == "Single"
                                        ? d?.purchase_order_s_details?.map(
                                            (value, index) => (
                                              <div className="text-holder">
                                                <p className="mb-0" key={index}>
                                                  {value?.unit}{" "}
                                                  {value?.unit_type}
                                                  <br />
                                                </p>
                                                <hr />
                                              </div>
                                            )
                                          )
                                        : d?.purchase_order_m_details?.map(
                                            (value, index) => (
                                              <div key={index}>
                                                {value?.purchase_order_m_sub_details?.map(
                                                  (data, subIndex) => (
                                                    <>
                                                      <div key={subIndex}>
                                                        {data?.unit}{" "}
                                                        {data?.unit_type}
                                                      </div>
                                                    </>
                                                  )
                                                )}
                                                <hr />
                                              </div>
                                            )
                                          )}
                                    </td>
                                  )}
                                  {visible.col11 && (
                                    <td>
                                      {d.type === "Single"
                                        ? d?.purchase_receive_singles?.map(
                                            (data, index) => (
                                              <div key={index}>
                                                {data?.unit} {data?.unit_type}{" "}
                                                <hr />
                                              </div>
                                            )
                                          )
                                        : d?.purchase_receive_multiple_mains?.map(
                                            (main, mainIndex) => (
                                              <div key={mainIndex}>
                                                {main?.purchase_receive_multiple_subs?.map(
                                                  (sub, subIndex) => (
                                                    <div
                                                      key={`${mainIndex}-${subIndex}`}
                                                    >
                                                      {sub?.unit}{" "}
                                                      {sub?.unit_type}
                                                    </div>
                                                  )
                                                )}{" "}
                                                <hr />
                                              </div>
                                            )
                                          )}
                                    </td>
                                  )}
                                  {visible.col8 && (
                                    <td>
                                      {d.status == 0 ? (
                                        <button
                                          type="button"
                                          className={`btn btn-sm ${
                                            d.status
                                              ? "btn-success"
                                              : "btn-warning"
                                          }`}
                                          disabled={!isAllow?.includes(249)}
                                          onClick={() => {
                                            GetEditData(d.id);
                                            handleShowStatus();
                                          }}
                                        >
                                          {d.status
                                            ? "Stock Received"
                                            : "Update Stock "}
                                        </button>
                                      ) : (
                                        "Stock Received"
                                      )}
                                    </td>
                                  )}
                                  {visible.col9 && (
                                    <td>
                                      <div className="d-flex">
                                        {isAllow?.includes(251) ? (
                                          d.status === 0 && (
                                            <Button
                                              onClick={() => handleShow1(d?.id)}
                                              type="button"
                                              className="btn btn-primary me-1"
                                            >
                                              <img
                                                src={pen}
                                                className="pen"
                                                alt=""
                                              />
                                            </Button>
                                          )
                                        ) : (
                                          <></>
                                        )}
                                        {isAllow?.includes(252) ? (
                                          d.status === 0 && (
                                            <button
                                              onClick={() => {
                                                showDeleteRecord(
                                                  d?.id,
                                                  d?.name
                                                );
                                              }}
                                              type="button"
                                              className="btn btn-danger"
                                            >
                                              <img
                                                src={basket}
                                                className="pen"
                                                alt=""
                                              />
                                            </button>
                                          )
                                        ) : (
                                          <></>
                                        )}
                                      </div>
                                    </td>
                                  )}
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan="10" className="text-center">
                                Data not available
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>{" "}
                      <Pagination_Holder
                        onPageChange={currentPage}
                        totalPages={totalPages}
                        handlePageChange={handlePageChange}
                      />
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>

      {show ? (
        <AddOffCanvance
          handleClose={handleClose}
          setShow={setShowAdd}
          show={show}
        />
      ) : (
        ""
      )}

      {show1 ? (
        <EditOffCanvance
          handleClose={handleClose1}
          setShow={setShowEdit}
          show={show1}
        />
      ) : (
        ""
      )}

      <Toaster position="top-right" />

      {/* <!-- Modal Delete --> */}
      <div className="upload-modal">
        <div
          className={`modal fade ${showDeleteModal ? "show" : ""}`}
          style={{ display: showDeleteModal ? "block" : "none" }}
          id="exampleModaldel"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog  modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <h1 className="add-success text-center  mt-2">
                  Are you sure ?
                </h1>
                <p>
                  Do You Really Want to Delete These Record?
                  <br /> This Process CanNot Be Undone{" "}
                </p>
                <div className="button-holder text-center mt-2">
                  <button className="btn btn-yes me-2" onClick={DeleteRecord}>
                    Yes
                  </button>
                  <button className="btn btn-no" onClick={handleDeleteCancel}>
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* status modal start */}
      {/* <Modal
        className="status-modal"
        show={showStatus}
        onHide={handleCloseStatus}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        animation={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-holder">
            <Form>
              <div className="row">
                <div className="col-md-6">
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Product</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter product Name"
                      disabled
                    />
                  </Form.Group>
                </div>
                <div className="col-md-6">
                  <Form.Group className="mb-3" controlId="formBasicPassword">
                    <Form.Label>Quantity</Form.Label>
                    <Form.Control type="number" placeholder="Enter Quantity" />
                  </Form.Group>
                </div>
              </div>
            </Form>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseStatus}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleCloseStatus}>
            Save
          </Button>
        </Modal.Footer>
      </Modal> */}

      <Modal
        className="status-modal"
        show={showStatus}
        onHide={handleCloseStatus}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        animation={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Received Quantity</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={6}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Form.Label>Type</Form.Label>
                  <Form.Group className="mb-3">
                    <InputGroup>
                      <Form.Control
                        type="number"
                        placeholder={receivedData?.type?.label}
                        required
                        disabled
                      />
                    </InputGroup>
                    {errors.message && (
                      <span className="text-danger">
                        {errors.message.message}
                      </span>
                    )}
                  </Form.Group>
                </Row>
              </div>
            </Col>
            <Col md={6}></Col>

            <Col md={6}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Form.Label>Product</Form.Label>
                  <Form.Group className="mb-3">
                    <InputGroup>
                      <Form.Control
                        type="number"
                        placeholder={receivedData?.product_id?.label}
                        required
                        disabled
                      />
                    </InputGroup>
                    {errors.message && (
                      <span className="text-danger">
                        {errors.message.message}
                      </span>
                    )}
                  </Form.Group>
                </Row>
              </div>
            </Col>
            <Col md={6}></Col>
          </Row>

          {receivedData?.type?.label === "Single" &&
            receivedData?.main_m_variants?.map((product, productIndex) => (
              <div key={productIndex} className="form-holder">
                <Form>
                  <div className="row  me-0 ms-0 p-0">
                    <Col md={3}>
                      <div className="main-form-section mt-3">
                        <Row className="row justify-content-center mb-2  me-0 ms-0 p-0">
                          <Form.Label>Products</Form.Label>
                          <Controller
                            name={`product.${productIndex}.product_single_v_id`}
                            control={control}
                            defaultValue={{
                              value: product.product_single_v_id?.value,
                              label: product.product_single_v_id?.label,
                            }}
                            rules={{ required: "Select Supplier" }}
                            render={({ field }) => (
                              <Select
                                {...field}
                                options={productOption}
                                isDisabled={true}
                                styles={{
                                  control: (baseStyles) => ({
                                    ...baseStyles,
                                    borderColor: errors.product?.[productIndex]
                                      ?.product_id
                                      ? "red"
                                      : baseStyles.borderColor,
                                  }),
                                }}
                              />
                            )}
                          />
                          {errors.product?.[productIndex]?.product_id && (
                            <span className="text-danger">
                              {errors.product[productIndex].product_id.message}
                            </span>
                          )}
                        </Row>
                      </div>
                    </Col>

                    <Col md={3}>
                      <div className="main-form-section mt-3">
                        <Row className="row justify-content-center mb-2">
                          <Form.Label>Unit Type</Form.Label>
                          <Controller
                            name={`product.${productIndex}.unit_type`}
                            control={control}
                            defaultValue={{
                              value: product.unit_type?.value,
                              label: product.unit_type?.label,
                            }}
                            rules={{ required: "Select Supplier" }}
                            render={({ field }) => (
                              <Select
                                {...field}
                                options={productOption}
                                isDisabled={true}
                                styles={{
                                  control: (baseStyles) => ({
                                    ...baseStyles,
                                    borderColor: errors.product?.[productIndex]
                                      ?.unit_type
                                      ? "red"
                                      : baseStyles.borderColor,
                                  }),
                                }}
                              />
                            )}
                          />
                          {errors.product?.[productIndex]?.unit_type && (
                            <span className="text-danger">
                              {errors.product[productIndex].unit_type.message}
                            </span>
                          )}
                        </Row>
                      </div>
                    </Col>

                    <Col md={3}>
                      <div className="main-form-section mt-3">
                        <Row className="justify-content-center">
                          <Form.Group
                            className="mb-3"
                            controlId={`formQuantity${productIndex}`}
                          >
                            <Form.Label>Unit</Form.Label>
                            <InputGroup>
                              <Form.Control
                                type="number"
                                placeholder="Enter Unit"
                                value={product.unit}
                                disabled
                              />
                            </InputGroup>
                          </Form.Group>
                        </Row>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="main-form-section mt-3">
                        <Row className="justify-content-center">
                          <Form.Label>Received Stock </Form.Label>
                          <Form.Group
                            className="mb-3"
                            controlId={`formQuantity${productIndex}`}
                          >
                            <InputGroup>
                              <Form.Control
                                type="number"
                                // defaultValue={product?.unit}
                                placeholder="Enter Received Stock"
                                {...register(`product.${productIndex}.unit`, {
                                  required: "Stock Unit is required",
                                  validate: (value) =>
                                    value <= product?.unit ||
                                    `Quantity cannot exceed ${product?.unit}`,
                                })}
                              />
                            </InputGroup>
                            {errors.product?.[productIndex]?.unit && (
                              <span className="text-danger">
                                {errors.product[productIndex].unit.message}
                              </span>
                            )}
                          </Form.Group>
                        </Row>
                      </div>
                    </Col>
                  </div>
                </Form>
              </div>
            ))}

          {receivedData?.type?.label === "Multiple" &&
            receivedData?.main_m_variants?.map((product, productIndex) => (
              <div key={productIndex} className="form-holder">
                <Form>
                  <div className="row ">
                    <Col md={6}>
                      <div className="main-form-section mt-3">
                        <Row className="row justify-content-center mb-2">
                          <Form.Label>Products</Form.Label>
                          <Controller
                            name={`product[${productIndex}].product_m_main_id`}
                            control={control}
                            defaultValue={{
                              value: product.product_m_main_id?.value,
                              label: product.product_m_main_id?.label,
                            }}
                            rules={{ required: "Select Supplier" }}
                            render={({ field }) => (
                              <Select
                                {...field}
                                options={productOption}
                                isDisabled={true}
                                styles={{
                                  control: (baseStyles) => ({
                                    ...baseStyles,
                                    borderColor: errors.product?.[productIndex]
                                      ?.product_id
                                      ? "red"
                                      : baseStyles.borderColor,
                                  }),
                                }}
                              />
                            )}
                          />
                          {errors.product?.[productIndex]?.product_id && (
                            <span className="text-danger">
                              {errors.product[productIndex].product_id.message}
                            </span>
                          )}
                        </Row>
                      </div>
                    </Col>

                    <Row className="me-0 ms-0 p-0">
                      {product?.m_variants?.map((value, valueIndex) => (
                        <React.Fragment key={valueIndex}>
                          <br></br>
                          <Row>
                            {" "}
                            <Col md={6}>
                              <div className="main-form-section mt-3">
                                <Row className="row justify-content-center mb-2">
                                  <Form.Label>Sub Variant</Form.Label>
                                  <Controller
                                    name={`product.${productIndex}.m_sub_variants.${valueIndex}.product_m_sub_v_id`}
                                    control={control}
                                    defaultValue={{
                                      value: value.product_m_sub_v_id?.value,
                                      label: value.product_m_sub_v_id?.label,
                                    }}
                                    rules={{ required: "Select Supplier" }}
                                    render={({ field }) => (
                                      <Select
                                        {...field}
                                        options={productOption}
                                        isDisabled={true}
                                        styles={{
                                          control: (baseStyles) => ({
                                            ...baseStyles,
                                            borderColor: errors.product?.[
                                              valueIndex
                                            ]?.product_id
                                              ? "red"
                                              : baseStyles.borderColor,
                                          }),
                                        }}
                                      />
                                    )}
                                  />
                                  {errors.product?.[valueIndex]?.product_id && (
                                    <span className="text-danger">
                                      {
                                        errors.product[valueIndex].product_id
                                          .message
                                      }
                                    </span>
                                  )}
                                </Row>
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="main-form-section mt-3">
                                <Row className="row justify-content-center mb-2">
                                  <Form.Label>Unit Type</Form.Label>
                                  <Controller
                                    name={`product.${productIndex}.m_sub_variants.${valueIndex}.unit_type`}
                                    control={control}
                                    defaultValue={{
                                      value: value.unit_type?.value,
                                      label: value.unit_type?.label,
                                    }}
                                    rules={{ required: "Select Supplier" }}
                                    render={({ field }) => (
                                      <Select
                                        {...field}
                                        options={productOption}
                                        isDisabled={true}
                                        styles={{
                                          control: (baseStyles) => ({
                                            ...baseStyles,
                                            borderColor: errors.product?.[
                                              valueIndex
                                            ]?.unit_type
                                              ? "red"
                                              : baseStyles.borderColor,
                                          }),
                                        }}
                                      />
                                    )}
                                  />
                                  {errors.product?.[valueIndex]?.unit_type && (
                                    <span className="text-danger">
                                      {
                                        errors.product[valueIndex].unit_type
                                          .message
                                      }
                                    </span>
                                  )}
                                </Row>
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="main-form-section mt-3">
                                <Row className="justify-content-center">
                                  <Form.Group
                                    className="mb-3"
                                    controlId={`formQuantity${valueIndex}`}
                                  >
                                    <Form.Label>Unit</Form.Label>
                                    <InputGroup>
                                      <Form.Control
                                        type="number"
                                        placeholder="Enter Unit"
                                        value={value.unit} // Set value directly
                                        disabled // Make it read-only
                                        readOnly // Optional: better accessibility
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="main-form-section mt-3">
                                <Row className="justify-content-center">
                                  <Form.Label>Received Stock</Form.Label>
                                  <Form.Group
                                    className="mb-3"
                                    controlId={`formQuantity${valueIndex}`}
                                  >
                                    <InputGroup>
                                      <Form.Control
                                        type="number"
                                        placeholder="Enter Received Stock"
                                        // defaultValue={value?.unit}
                                        required
                                        {...register(
                                          `product.${productIndex}.m_sub_variants.${valueIndex}.unit`,
                                          {
                                            required: "Stock Unit is required",
                                            min: {
                                              value: 0,
                                              message:
                                                "Quantity cannot be negative",
                                            },
                                            max: {
                                              value: value?.unit || 0, // Ensure max is dynamically set to value?.unit
                                              message: `Quantity cannot exceed ${value?.unit}`,
                                            },
                                          }
                                        )}
                                      />
                                    </InputGroup>
                                    {errors.product?.[productIndex]
                                      ?.m_sub_variants?.[valueIndex]?.unit && (
                                      <span className="text-danger">
                                        {
                                          errors.product[productIndex]
                                            .m_sub_variants[valueIndex].unit
                                            .message
                                        }
                                      </span>
                                    )}
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col>
                          </Row>
                          <br></br>
                        </React.Fragment>
                      ))}
                    </Row>
                  </div>
                </Form>
              </div>
            ))}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseStatus}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit(ChangeStatusReceive)}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      <Successfull_Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        message={"Order Recieved Successfully!"}
      />

      {/* status modal end */}
    </>
  );
};

export default Tables;
